import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import axios from "axios";
class FileUploadStore {
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      uploadFile: action,
    });
    this.rootStore = rootStore;

    this.uploadFile = this.uploadFile.bind(this);

    console.log("first");
  }

  async uploadFile({ file, token, onProgress, fileType, fieldName, url }) {
    console.log(url, "url", token, fileType, fieldName, file);
    // try {
    //   const formData = new FormData();
    //   formData.append(fieldName, file);
    //   formData.append("fileType", fileType);
    //   formData.append("fieldName", fieldName);

    //   const response = await axios.post(url, formData, {
    //     headers: {
    //       token: token,
    //       "Content-Type": "multipart/form-data",
    //     },
    //     onUploadProgress: (event) => {
    //       const percent = Math.round((event.loaded * 100) / event.total);
    //       this.uploadProgress = percent; // update observable
    //       if (onProgress) onProgress({ percent });
    //     },
    //   });

    //   return response.data;
    // } catch (error) {
    //   throw error;
    // }

    // try {
    //   const formData = new FormData();
    //   formData.append("logo", file);
    //   formData.append("fileType", "companylogo");
    //   formData.append("fieldName", "logo");

    //   console.log(this.state.token, "token");
    //   const response = await axios.post(
    //     // config.baseURL + this.companyStore.fileUploadUrl,
    //     config.NodeUrl + "/company/fileUpload",
    //     formData,
    //     {
    //       headers: {
    //         token: this.state.token,
    //         "Content-Type": "multipart/form-data",
    //       },
    //       onUploadProgress: (event) => {
    //         const percent = Math.round((event.loaded * 100) / event.total);
    //         onProgress({ percent });
    //       },
    //     }
    //   );

    //   onSuccess(response.data);
    // } catch (error) {
    //   onError(error);
    // }
  }
}

export default FileUploadStore;
